angular.module('execution-deadline')
    .component('executionDeadlineList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/execution-deadline/list.html',
        controller: function ($scope, $state, ExecutionDeadlineService) {
            this.ExecutionDeadlineService = ExecutionDeadlineService;
            this.reset = () => this.filters = {}
            $scope.$on('executiondeadline.updated', () => $state.reload());
        }
    })
